module.exports = __webpack_public_path__ + "static/media/2 Train-AP_Z1.2a874e92.png";